import React from "react";

export default function HeroStat({ icon: Icon, value, label }) {
  return (
    <div
      className="
        rounded-[16px] sm:rounded-[20px]
        border border-white/10
        bg-white/[0.08]
        p-2 sm:p-3
        flex flex-col items-center justify-center
        text-center
      "
    >
      {/* ICON */}
      <div
        className="
          h-6 w-6 sm:h-8 sm:w-8
          rounded-[10px] sm:rounded-[14px]
          bg-white/10
          border border-white/10
          flex items-center justify-center
          mb-1 sm:mb-1.5
        "
      >
        <Icon className="w-3.5 h-3.5 sm:w-[15px] sm:h-[15px] text-white/90" />
      </div>

      {/* VALUE */}
      <p className="text-[13px] sm:text-[16px] font-semibold tracking-tight text-white leading-none">
        {value}
      </p>

      {/* LABEL */}
      <p className="mt-0.5 text-[8.5px] sm:text-[10px] font-medium text-white/70 leading-snug truncate w-full px-0.5">
        {label}
      </p>
    </div>
  );
}